import {
  specialWaitings,
  WAITING
} from "components/Cards/Waiting/Waiting.helper";
import { WORK_COMPLETED, EXTRA_ACTIONS_REQUIRED } from "constants/mission";

const specialEventTypes = [WAITING, WORK_COMPLETED];

const getWaitingType = ({ description }) =>
  specialWaitings.includes(description) ? description : WAITING;

const getWorkCompletedType = ({ moreInformation }) =>
  moreInformation === EXTRA_ACTIONS_REQUIRED ? moreInformation : WORK_COMPLETED;
const specialEventTypesMap = {
  WAITING: getWaitingType,
  WORK_COMPLETED: getWorkCompletedType
};
export const useCardDescription = ({ type, description, moreInformation }) => {
  return {
    eventType: specialEventTypes.includes(type)
      ? specialEventTypesMap[type]({ description, moreInformation })
      : type
  };
};
